<template>
  <section>
    <Header :state="state"></Header>
    <div class="content_wrap">
      <div class="wrap_img">
        <img src="/static/images/contactusbg.png" alt="">
      </div>
      <el-row class="wrap_desc">
        <el-col :span="8">
          <div class="wrap_ul">
            <p class="li_name">北京瑞森永安科技有限公司</p>
            <p class="li_line">销售热线：131 0270 1269</p>
            <p class="li_line">服务热线：131 0270 1269</p>
            <p class="li_line">电子邮箱：service@risafety.com</p>
            <p class="li_line">公司地址：北京市朝阳区静安庄一区2号院院内办公楼东门2层210室</p>
            <div class="li_con">
              <img src="/static/images/wxPic.png" alt="">
              <span>(关注微信公众号)</span>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="wrap_map">
            <div id="amap"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </section>
</template>
<script>
import Header from '../components/common/header'
import Footer from '../components/common/footer'
export default {
  name: 'home',
  components: { Header,Footer },
  data () {
    const self = this;
    return {
      state:2,
      amap:''
    }
  },
  mounted(){
    this.initMap();
  },
  created(){

  },
  methods:{
    initMap(){
      let amap=new AMap.Map("amap",{
        center:[116.44587,39.958693],
        resizeEnable:true,
        zoom:14,
        lang:'ch',
      })
      AMap.plugin(['AMap.ToolBar','AMap.Scale'],function(){
        amap.addControl(new AMap.ToolBar())
        amap.addControl(new AMap.Scale())
      })
      let marker = new AMap.Marker({
        position: [116.44587,39.958693],
        icon: new AMap.Icon({
          size: new AMap.Size(20, 28), // 图标尺寸
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',//绝对路径
          imageSize: new AMap.Size(20, 28)
        }),
        offset: new AMap.Pixel(-13, -30)
      });
      marker.setMap(amap);
    },
  }
}
</script>
<style lang="less" scoped>
.amap-demo {
  height: 4.4rem;
}
.content_wrap{
  padding: 0 0 0.7rem;
  .wrap_img{
    width: 100%;
    height: 4rem;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .wrap_desc{
    width: 100%;
    padding: 0.7rem 14%;
    .wrap_ul{
      text-align: left;
      line-height: 0.24rem;
      font-size: 0.17rem;
      color: #333333;
      .li_name{
        line-height: 0.38rem;
        font-size: 0.27rem;
        font-weight: 500;
        color: #333333;
      }
      .li_line{
        margin: 0.27rem 0;
        line-height: 0.4rem;
      }
      .li_con{
        position: relative;
        img{
          width: 1.7rem;
          height: 1.7rem;
          position: absolute;
          left: 0;
          top: 0;
        }
        span{
          position: absolute;
          top: 1.4rem;
          left: 1.74rem;
        }
      }
    }
    .wrap_map{
      width: 100%;
      height: 4.4rem;
      #amap{
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media screen and(min-width: 1680px){
  .amap-demo {
    height: 440px;
  }
  .content_wrap{
    padding: 0 0 70px;
    .wrap_img{
      width: 100%;
      height: 400px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .wrap_desc{
      width: 100%;
      padding: 70px 14%;
      .wrap_ul{
        text-align: left;
        line-height: 24px;
        font-size: 17px;
        color: #333333;
        .li_name{
          line-height: 38px;
          font-size: 27px;
          font-weight: 500;
          color: #333333;
        }
        .li_line{
          margin: 27px 0;
          line-height: 40px;
        }
        .li_con{
          position: relative;
          img{
            width: 170px;
            height: 170px;
            position: absolute;
            left: 0;
            top: 0;
          }
          span{
            position: absolute;
            top: 140px;
            left: 174px;
          }
        }
      }
      .wrap_map{
        width: 100%;
        height: 440px;
        #amap{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
<style>
.amap-logo{
  display: none !important;
}
.amap-copyright{
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue